import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ChartIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M4 3a1 1 0 0 0-2 0v18c0 .6.4 1 1 1h18a1 1 0 1 0 0-2H4V3Z" />
    <path d="M19 9a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0V9Zm-6-5c.6 0 1 .4 1 1v12a1 1 0 1 1-2 0V5c0-.6.4-1 1-1ZM9 14a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Z" />
  </Icon>
));
export default ChartIcon;
